import { render } from "./espece.vue?vue&type=template&id=e439885e&scoped=true"
import script from "./espece.vue?vue&type=script&lang=js"
export * from "./espece.vue?vue&type=script&lang=js"

import "./espece.vue?vue&type=style&index=0&id=e439885e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e439885e"]])

export default __exports__